function scrollIndicator() {
	let height = document.documentElement.scrollHeight - document.documentElement.clientHeight - footerHeight;
	if (window.innerWidth < 768) {
		height = document.documentElement.scrollHeight - document.documentElement.clientHeight - footerHeight - sidebarHeight;
	}
	const scrolled = (window.scrollY / height) * 100;
	blogScrollProgressBar.style.width = scrolled + "%";
}
